import { render, staticRenderFns } from "./normal-upload.vue?vue&type=template&id=f16864d8&scoped=true&"
import script from "./normal-upload.vue?vue&type=script&lang=js&"
export * from "./normal-upload.vue?vue&type=script&lang=js&"
import style0 from "./normal-upload.vue?vue&type=style&index=0&id=f16864d8&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f16864d8",
  null
  
)

export default component.exports